import React, {useState} from "react";
import Box from "@material-ui/core/Box";
import {DateRangePicker} from 'react-date-range'
import * as locales from 'react-date-range/dist/locale';
import Moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import Popover from "@material-ui/core/Popover";
import DateRangeIcon from '@material-ui/icons/DateRange';
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import {useTranslation} from "react-i18next";
import i18next from "../../../i18n/i18next";
import {DatePicker ,MuiPickersUtilsProvider} from "@material-ui/pickers";

const MonthPicker = ({name, minDate, maxDate, setState, state, label}) => {
    const {t} = useTranslation()
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const lng = localStorage.getItem(`iChain_lang`) || 'en'
    const locale = locales[lng]
    
    return <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale} name={name}>
        <Box display="flex" alignItems="center" gap={1}>
            <IconButton
                onClick={() => setState(Moment(state).add(-1,"months").toDate())}
                disabled={minDate && Moment(state).isSameOrBefore(minDate, "month")}
            >
                <ArrowBack />
            </IconButton>
            <DatePicker
                views={["year","month"]}
                label={label}
                minDate={minDate}
                maxDate={maxDate?maxDate:Moment()}
                value={state}
                onChange={(date)=>{
                    setState(date)
                }}
                disableFuture={true}
                variant="inline"
            />
            {/* freccia destra */}
            <IconButton
                onClick={() => setState(Moment(state).add(1,"months").toDate())}
                disabled={Moment(state).isSameOrAfter(maxDate?maxDate:Moment(), "month")}
            >
                <ArrowForward />
            </IconButton>
        </Box>
    </MuiPickersUtilsProvider>
}

export default MonthPicker;